export const FormFieldsMap = {
  ActivityOutcome: {
    key: 'activityOutcome'
  },
  ActivityOutcomeComments: {
    key: 'activityOutcomeComments'
  }
};
